
import { Component, Vue } from 'vue-property-decorator';
import { parceriaStore, mainStore, userToolStore, companyStore, bucketStore } from '@/store';
import Show from './Show.vue';
import { IParceria } from '@/interfaces/parceria';
import Register from './Register.vue';

@Component({
  components: {
    Show,
    Register,
  },
})
export default class InvoiceList extends Vue {
  public headers = [
    {
      text: 'Preview',
      value: 'preview',
      align: 'left',
    },
    {
      text: 'Parceria',
      sortable: true,
      value: 'title',
      align: 'left',
    },
    {
      text: 'UF',
      sortable: true,
      value: 'coverage.modelUF',
      align: 'center',
    },
    //     {
    //   text: "Cidades",
    //   sortable: true,
    //   value: "coverage.modelMunicipio",
    //   align: "left",
    // },
    {
      text: 'Ações',
      value: 'actions',
    },
  ];

  public isLoading = true;

  public search = '';

  public searchUF: any = '';

  public selectedItem = {};

  public allowCreate = false;

  public allowView = false;

  public allowDelete = false;

  public allowEdit = false;

  public items: IParceria[] = [];

  public showAllParcerias = true;

  public page = 1;

  public itemsPerPage = 8;

  public companyInfo = {
    city: undefined,
    uf: undefined,
  };

  get franchisingName() {
    return mainStore.franchisingName;
  }

  get images() {
    return bucketStore.images;
  }

  get parceriaTool() {
    return userToolStore.currentUserTools.find((t) => t.tool_id === 27);
  }

  get userProfile() {
    return mainStore.userProfile;
  }

  get filteredItems() {
    let items = this.items; // this.items = TODAS AS PARCERIAS
    if (this.searchUF) {
      // SE TIVER UF -> FILTRA SOMENTE AS PARCERIAS COM A UF
      items = this.items.filter((item) => {
        return item['coverage']['modelUF'].some((uf) => uf === this.searchUF);
      });
    }
    if (this.search) {
      return items.filter((i) => i.title.toLowerCase().includes(this.search.toLowerCase()));
    }
    return items;
  }

  public async mounted() {
    await parceriaStore.getParcerias(1); // 1 -> retorna todas / filtro feito no frontEnd
    this.items = parceriaStore.parcerias;

    this.items.forEach((item) => {
      item['coverage'].modelUF.sort();
    });

    const info = await companyStore.getCompany({
      id: this.userProfile!.company_id,
    });
    this.companyInfo.city = info['city_codigo_municipio_completo'];
    this.companyInfo.uf = info['uf'].toLowerCase();

    await bucketStore.getImages('parceria');

    this.items.forEach((item) => {
      item['preview'] = this.images[item['id']];
    });
    this.isLoading = false;
  }

  public async updateList() {
    this.isLoading = true;
    await parceriaStore.getParcerias(1); // 1 -> retorna todas / filtro feito no frontEnd
    this.items = parceriaStore.parcerias;
    await bucketStore.getImages('parceria');
    this.items.forEach((item) => {
      item['preview'] = this.images[item['id']];
    });
    this.isLoading = false;
  }

  public editParceria(parceria) {
    const el: any = this.$refs.registerParceria;
    el.dialog = true;
    el.parceria = parceria;
    // el.abrangencia = parceria.coverage
  }

  public async deleteParceria(parceria) {
    await this.$swal({
      title: 'Remover parceria?',
      icon: 'warning',
      html: `Tem certeza que deseja excluir a parceria <b>${parceria.title}</b>?<br>`,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await bucketStore.deleteFromBucketById({
          bucket_name: 'parceria',
          id: String(parceria.id),
        });
        await parceriaStore.deleteParceria(parceria.id);
      }
    });
    await this.updateList();
  }

  public switchParceria(parceria) {
    if (Array.isArray(parceria.preview)) {
      parceria.preview = parceria.preview[0];
    }
    this.showParcerias(parceria);
  }

  public showParcerias(item: any) {
    let form: any = this.$refs.show;
    let lastSixParcerias = this.items.slice(0, 6);
    form.show(item, lastSixParcerias);
  }
}
